module.exports = __webpack_public_path__ + "nc_static/media/home.58597604.svg";